import { render, staticRenderFns } from "./DaihexiaoOrder.vue?vue&type=template&id=ea96e720&"
import script from "./DaihexiaoOrder.vue?vue&type=script&lang=js&"
export * from "./DaihexiaoOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports